import React from "react";

export default function UserSidebar({
  onlineUsers = [],
  onInvite,
  currentGameId,
  busyUserIds = [],
  user,
  setInviteTarget,
  setInviteModalOpen,
}) {
  return (
    <aside className="w-full max-w-xs bg-slate-900/95 p-4 rounded-2xl shadow-lg">
      <h3 className="text-lime-400 text-xl font-extrabold mb-3 pl-1">
        Online Players
      </h3>
      <div className="flex flex-col gap-2">
        {(!onlineUsers || onlineUsers.length === 0) && (
          <div className="text-gray-400 italic pl-2">No one online</div>
        )}
        {onlineUsers &&
          onlineUsers.map((u) => {
            const isBusy = busyUserIds.includes(u.userId);
            const isSelf = user?.uid === u.userId;
            return (
              <div
                key={u.userId}
                className="flex items-center justify-between bg-slate-800/80 rounded-xl px-3 py-2 gap-3 shadow-sm hover:bg-slate-700 transition-all min-w-0"
              >
                <div className="flex items-center gap-3 min-w-0">
                  {u.avatar ? (
                    <img
                      src={u.avatar}
                      alt={u.username || "Player"}
                      className="w-9 h-9 rounded-full border-2 border-lime-400 object-cover"
                    />
                  ) : (
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-orange-500 text-white font-bold text-base border-2 border-lime-400">
                      {(u.username?.[0] || "U").toUpperCase()}
                    </div>
                  )}
                  <span
                    className="font-medium text-white truncate max-w-[80px] sm:max-w-[120px]"
                    title={u.username || "Player"}
                  >
                    {u.username?.length > 14
                      ? u.username.slice(0, 12) + "…"
                      : u.username || "Player"}
                  </span>
                </div>
                <button
                  aria-label={`Invite ${u.username || "Player"}`}
                  onClick={() => {
                    setInviteTarget(u);
                    setInviteModalOpen(true);
                  }}
                  className={`font-semibold px-4 py-1 rounded-lg text-xs shadow ml-1
                    ${
                      isBusy || isSelf
                        ? "bg-gray-400 text-gray-800 cursor-not-allowed"
                        : "bg-lime-400 hover:bg-lime-500 text-slate-900"
                    }
                  `}
                  disabled={currentGameId || isBusy || isSelf}
                >
                  {isBusy ? "Busy" : isSelf ? "You" : "Invite"}
                </button>
              </div>
            );
          })}
      </div>
    </aside>
  );
}
